import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  ICreateMotoristaExternoBody,
  IGetMotoristaExternoByIdResponse,
  ILoginMotoristaExternoBody,
  IUpdateMotoristaExternoBody,
  IUpdateMotoristaExternoResponse
} from './motoristaExterno.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MotoristaExternoService {
  constructor(private http: HttpClient) {}

  public CreateMotoristaExterno(
    body: ICreateMotoristaExternoBody
  ): Observable<any> {
    const url = `${environment.baseURL}MotoristaExterno/CreateMotoristaExterno`;
    return this.http.post<any>(url, body);
  }

  public LoginMotoristaExterno(
    body: ILoginMotoristaExternoBody
  ): Observable<any> {
    const url = `${environment.baseURL}MotoristaExterno/LoginMotoristaExterno`;
    return this.http.post<any>(url, body);
  }

  public GetMotoristaExternoById(
    id: number
  ): Observable<IGetMotoristaExternoByIdResponse> {
    const url = `${environment.baseURL}MotoristaExterno/GetMotoristaExternoById?id=${id}`;
    return this.http.get<any>(url);
  }

  public UpdateMotoristaExterno(
    body: IUpdateMotoristaExternoBody,
    id: number
  ): Observable<IUpdateMotoristaExternoResponse> {
    const url = `${environment.baseURL}MotoristaExterno/UpdateMotoristaExterno?id=${id}`;
    return this.http.put<any>(url, body);
  }

  public PacthMotoristaExternoResetSenha(
    ResetToken: string,
    TX_SENH_EXTR: string
  ): Observable<any> {
    const url = `${environment.baseURL}MotoristaExterno/PacthMotoristaExternoResetSenha`;
    const body = {
      ResetToken,
      TX_SENH_EXTR
    };
    return this.http.patch<any>(url, body);
  }
}
